import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from "lodash";
import { List } from "immutable";
import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";

// Actions
import { getEmployees, changeEmployeeStatus, cleanEmployees } from "../../actions/employees";

// Components
import VirtualizedTable from "../../components/common/virtualized-table";

const queryOptions = {
    projection: 'employee_code name last_name email phone mobile_phone fiscal_id status'
};

class EmployeesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            employeesFilter: ''
        };
    }
    componentDidMount() {
      this.props.getEmployees(queryOptions);
    };
    componentWillUnmount() {
        this.props.cleanEmployees();
    }

    render() {
        let tableData = this.props.employees;

        // Filters Zone
        let statusZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.employees.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ employeesFilter: '' }) } ><strong>Total</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.employees.count(employee => employee.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.employees.count(employee => employee.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'inactive' }) } >Inactivos</span>
                </div>
            </div>
        );
        switch (this.state.employeesFilter) {
            case 'active':
                statusZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.employees.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.employees.count(employee => employee.get('status') === 'active') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'active' }) } ><strong>Activos</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.employees.count(employee => employee.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                    </div>
                );
                tableData = this.props.employees.filter( employee => employee.get('status') === 'active' );
                break;
            case 'inactive':
                statusZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.employees.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.employees.count(employee => employee.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.employees.count(employee => employee.get('status') === 'inactive') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ employeesFilter: 'inactive' }) } ><strong>Inactivos</strong></span>
                        </div>
                    </div>
                );
                tableData = this.props.employees.filter( employee => employee.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        // Employees Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            employee_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'employee_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/empleados/' + value[0] }>{ value[1] }</Link>
                }
            },
            name: {
                title: "Nombre",
                columnType: 'function',
                dataField: ['_id', 'name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/empleados/' + value[0] }>{ value[1] }</Link>
                }
            },
            last_name: {
                title: "Apellidos",
                columnType: 'function',
                dataField: ['_id', 'last_name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/empleados/' + value[0] }>{ value[1] }</Link>
                }
            },
            email: {
                title: "Email",
                columnType: 'text',
                dataField: 'email',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            phone: {
                title: "Teléfono",
                columnType: 'text',
                dataField: 'phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true,
            },
            mobile_phone: {
                title: "Móvil",
                columnType: 'text',
                dataField: 'mobile_phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true,
            },
            fiscal_id: {
                title: "CIF/NIF",
                columnType: 'text',
                dataField: 'fiscal_id',
                width: 200,
                style: {},
                sortable: false,
                filterable: true,
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/empleados/' + value[0])} />
                            <MenuItem
                                icon="eye-open"
                                text="Registrar trabajo"
                                onClick={ () => this.props.history.push(`/empleados/${value[0]}/registro`, { openNewWorkReport: true })}
                            />
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeEmployeeStatus(value[0], 'inactive', queryOptions) } icon="eye-off" text="Desactivar" />
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeEmployeeStatus(value[0], 'active', queryOptions) } icon="eye-off" text="Activar" />
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active">
                                <strong>Empleados</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/empleados/nuevo') } > <Icon icon="insert"/>Empleado</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            { statusZone }
                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const employeesReducer = state.employees;

    // Employees
    let employees = employeesReducer.get('payload') || List([]);
    if (!(employees instanceof List)) employees = List([]);

    return {
        employees
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployees: (query) => dispatch(getEmployees(query)),
        changeEmployeeStatus: (employeeId, status, options) => dispatch(changeEmployeeStatus(employeeId, status, options)),
        cleanEmployees: () => dispatch(cleanEmployees())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesPage);


// WEBPACK FOOTER //
// ./src/containers/employees/EmployeesPage.js